// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC<{ width?: number; height?: number }> = ({ width = 25, height = 23 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 23">
            <path
                fill="currentColor"
                d="M19.673913,0 L23.5326087,0 L15.1630435,9.73076923 L25,23 L17.2826087,23 L11.25,14.9831731 L4.34782609,23 L0.489130435,23 L9.45652174,12.6057692 L0,0 L7.88043478,0 L13.3695652,7.35336538 L19.673913,0 Z M18.3152174,20.6778846 L20.4891304,20.6778846 L6.73913043,2.21153846 L4.45652174,2.21153846 L18.3152174,20.6778846 Z"
            />
        </svg>
    );
};

export default React.memo(Twitter);
